import { render, staticRenderFns } from "./Font.vue?vue&type=template&id=bf75e3a0"
import script from "./Font.vue?vue&type=script&lang=js"
export * from "./Font.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports